const Header = () => {
  return (
    <header data-testid="header" className="flex justify-center px-10 py-5 shadow-md bg-abnamro-green">
      <h1 data-testid="app-title" className="text-2xl text-white">
        TV Show App
      </h1>
    </header>
  )
}

export default Header;
